import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import About from './pages/About';
import Help from './pages/Help';
import AdminSignup from './pages/AdminSignup';
import Login from './pages/Login';
import OtpVerification from "./pages/OtpVerification";
import Signup from './pages/Signup';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Forgotpassword from './pages/Forgotpassword';
import PrivateRoute from './components/dashboard/PrivateRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/css/materialdesignicons.css';
import './App.css';

const App = () => {
  return (
    <Router>
      <Routes>
       <Route path="/login" element={<Login />} />
        <Route path="/" element={<Navigate replace to="/login" />} />
        <Route path="*" element={<Navigate replace to="/login" />} />
        <Route path="/otp-verification" element={<OtpVerification />} />
        <Route path="/about" element={<About />} />
        <Route path="/help" element={<Help />} />
        <Route path="/forgotpassword" element={<Forgotpassword />} />
        <Route path="/resetpassword" element={<ResetPassword />} />
        <Route path="/signup" element={<Signup />} />      
        <Route path="/adminsignup" element={<AdminSignup />} />      
        
        {/* Protected Route for Dashboard */}
        <Route 
          path="/dashboard/*" 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } 
        />       
      </Routes>
    </Router>
  );
};

export default App;
